export default "__VITE_ASSET__B$X1ksWZ__"